export default __webpack_public_path__ + "96fc6a3508914be93acb098393df9d67.png";